'use client';

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from 'next-themes';
export const UIProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["light", "dark"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ThemeProvider attribute="class" defaultTheme="system" disableTransitionOnChange={true} enableSystem={true} themes={t1}>{children}</ThemeProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export { useTheme } from 'next-themes';